import { render, staticRenderFns } from "./pay_link.vue?vue&type=template&id=ba4de95e&"
import script from "./pay_link.vue?vue&type=script&lang=js&"
export * from "./pay_link.vue?vue&type=script&lang=js&"
import style0 from "./pay_link.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports